var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgElectricCarChargersbefore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid slice",
    viewBox: "0 0 1258 981.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n   .electricCarChargers_before_svg__cls-4{fill:#343a50}.electricCarChargers_before_svg__cls-5{fill:#eb9a6b}.electricCarChargers_before_svg__cls-13,.electricCarChargers_before_svg__cls-16,.electricCarChargers_before_svg__cls-8{fill:#dedede}.electricCarChargers_before_svg__cls-12,.electricCarChargers_before_svg__cls-18,.electricCarChargers_before_svg__cls-19,.electricCarChargers_before_svg__cls-21,.electricCarChargers_before_svg__cls-22,.electricCarChargers_before_svg__cls-23,.electricCarChargers_before_svg__cls-24,.electricCarChargers_before_svg__cls-25,.electricCarChargers_before_svg__cls-26,.electricCarChargers_before_svg__cls-30,.electricCarChargers_before_svg__cls-37,.electricCarChargers_before_svg__cls-38,.electricCarChargers_before_svg__cls-42,.electricCarChargers_before_svg__cls-45,.electricCarChargers_before_svg__cls-46,.electricCarChargers_before_svg__cls-47,.electricCarChargers_before_svg__cls-52,.electricCarChargers_before_svg__cls-54,.electricCarChargers_before_svg__cls-59,.electricCarChargers_before_svg__cls-8,.electricCarChargers_before_svg__cls-9{stroke:#343a50}.electricCarChargers_before_svg__cls-45,.electricCarChargers_before_svg__cls-46,.electricCarChargers_before_svg__cls-47,.electricCarChargers_before_svg__cls-8{stroke-linecap:round}.electricCarChargers_before_svg__cls-45,.electricCarChargers_before_svg__cls-46,.electricCarChargers_before_svg__cls-8{stroke-linejoin:round}.electricCarChargers_before_svg__cls-12,.electricCarChargers_before_svg__cls-18,.electricCarChargers_before_svg__cls-46,.electricCarChargers_before_svg__cls-47,.electricCarChargers_before_svg__cls-8,.electricCarChargers_before_svg__cls-9{stroke-width:2px}.electricCarChargers_before_svg__cls-9{fill:#7fc3ca}.electricCarChargers_before_svg__cls-12,.electricCarChargers_before_svg__cls-18,.electricCarChargers_before_svg__cls-19,.electricCarChargers_before_svg__cls-21,.electricCarChargers_before_svg__cls-22,.electricCarChargers_before_svg__cls-23,.electricCarChargers_before_svg__cls-24,.electricCarChargers_before_svg__cls-25,.electricCarChargers_before_svg__cls-26,.electricCarChargers_before_svg__cls-30,.electricCarChargers_before_svg__cls-37,.electricCarChargers_before_svg__cls-38,.electricCarChargers_before_svg__cls-42,.electricCarChargers_before_svg__cls-47,.electricCarChargers_before_svg__cls-52,.electricCarChargers_before_svg__cls-54,.electricCarChargers_before_svg__cls-59,.electricCarChargers_before_svg__cls-9{stroke-miterlimit:10}.electricCarChargers_before_svg__cls-10{fill:#bc8264}.electricCarChargers_before_svg__cls-12{fill:#89bb21}.electricCarChargers_before_svg__cls-13,.electricCarChargers_before_svg__cls-15{mix-blend-mode:multiply}.electricCarChargers_before_svg__cls-14{fill:#6b472d}.electricCarChargers_before_svg__cls-18,.electricCarChargers_before_svg__cls-29,.electricCarChargers_before_svg__cls-34,.electricCarChargers_before_svg__cls-35,.electricCarChargers_before_svg__cls-59{fill:#fff}.electricCarChargers_before_svg__cls-19{fill:#a81628}.electricCarChargers_before_svg__cls-19,.electricCarChargers_before_svg__cls-21,.electricCarChargers_before_svg__cls-22,.electricCarChargers_before_svg__cls-23,.electricCarChargers_before_svg__cls-24,.electricCarChargers_before_svg__cls-25,.electricCarChargers_before_svg__cls-26,.electricCarChargers_before_svg__cls-30,.electricCarChargers_before_svg__cls-38,.electricCarChargers_before_svg__cls-45,.electricCarChargers_before_svg__cls-52,.electricCarChargers_before_svg__cls-54,.electricCarChargers_before_svg__cls-59{stroke-width:3px}.electricCarChargers_before_svg__cls-21{fill:#525254}.electricCarChargers_before_svg__cls-22{fill:#4254bc}.electricCarChargers_before_svg__cls-23,.electricCarChargers_before_svg__cls-45{fill:#ffccb5}.electricCarChargers_before_svg__cls-24{fill:#ba9079}.electricCarChargers_before_svg__cls-25{fill:#404040}.electricCarChargers_before_svg__cls-26{fill:#ce2232}.electricCarChargers_before_svg__cls-46,.electricCarChargers_before_svg__cls-47{fill:none}.electricCarChargers_before_svg__cls-29{opacity:.17}.electricCarChargers_before_svg__cls-30{fill:#fff300}.electricCarChargers_before_svg__cls-34{opacity:.32}.electricCarChargers_before_svg__cls-37{fill:#201a1a;stroke-width:3.64px}.electricCarChargers_before_svg__cls-38{fill:#e5e5e5}.electricCarChargers_before_svg__cls-42{fill:#3f3b3a;stroke-width:2.8px}.electricCarChargers_before_svg__cls-52{fill:#aaa}.electricCarChargers_before_svg__cls-54{fill:#fcfcfc}\r\n  "))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_before_svg__Ebene_1",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_before_svg__E-Tankstellen_Vorher"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "electricCarChargers_before_svg__Himmel",
    width: 1258,
    height: 632.62,
    y: -98.04,
    fill: "#a5d1d6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_before_svg__Wiese"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1260,
    height: 272.75,
    x: -1,
    y: 533.17,
    fill: "#a9bf5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 534.17v270.75H0V534.17h1258m2-2H-2v274.75h1262V532.17z",
    className: "electricCarChargers_before_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_before_svg__Haus_rechts"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 445.18,
    height: 219.65,
    x: -1,
    y: 312.42,
    className: "electricCarChargers_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.18 313.42v217.65H0V313.42h443.18m2-2H-2v221.65h447.18V311.42z",
    className: "electricCarChargers_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 165.47,
    height: 191.35,
    x: 48.58,
    y: 340.72,
    fill: "#bc7353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213 341.72v189.35H49.57V341.72H213m2-2H47.57v193.35H215V339.72z",
    className: "electricCarChargers_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 132.83,
    height: 179.85,
    x: 63.79,
    y: 352.22,
    fill: "#d38259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.62 353.22v177.85H64.79V353.22h130.83m2-2H62.79v181.85h134.83V351.22z",
    className: "electricCarChargers_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.58,
    x2: 64.79,
    y1: 341.72,
    y2: 353.22,
    className: "electricCarChargers_before_svg__cls-8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.04,
    x2: 195.62,
    y1: 341.72,
    y2: 353.22,
    className: "electricCarChargers_before_svg__cls-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.32 532.59 90.3 532.11 90.3 364.42 172.32 364.42 172.32 532.59",
    className: "electricCarChargers_before_svg__cls-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.1 532.56 129.1 488.05 90.29 488.05 90.29 483.62 129.1 483.62 129.1 364.7 133.52 364.7 133.52 483.62 172 483.62 172 488.05 133.52 488.05 133.52 532.56 129.1 532.56",
    className: "electricCarChargers_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.52 365.7v118.92H171v2.43h-38.48v44.51h-2.42v-44.51H91.29v-2.43h38.81V365.7h2.42m2-2h-6.42v118.92H89.28v6.43h38.8v44.51h6.42v-44.51H173v-6.43h-38.48V363.7z",
    className: "electricCarChargers_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 99.56,
    height: 163.3,
    x: 336.41,
    y: 340.62,
    className: "electricCarChargers_before_svg__cls-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.27 503.64 381.27 427.11 336.39 427.11 336.39 417.21 381.27 417.21 381.27 340.62 391.13 340.62 391.13 417.21 435.94 417.21 435.94 427.11 391.13 427.11 391.13 503.64 381.27 503.64",
    className: "electricCarChargers_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.12 341.62v76.59h44.82v7.9h-44.82v76.53h-7.84v-76.53H337.4v-7.9h44.88v-76.59h7.84m2-2h-11.85v76.59h-44.88v11.9h44.88v76.54h11.86v-76.54h44.81v-11.9h-44.81v-76.59z",
    className: "electricCarChargers_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 99.56,
    height: 163.3,
    x: 228.17,
    y: 340.64,
    className: "electricCarChargers_before_svg__cls-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.16 503.67 273.16 427.24 228.4 427.24 228.4 417.35 273.16 417.35 273.16 340.87 282.99 340.87 282.99 417.35 327.69 417.35 327.69 427.24 282.99 427.24 282.99 503.67 273.16 503.67",
    className: "electricCarChargers_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 341.87v76.48h44.7v7.89H282v76.43h-7.83v-76.43H229.4v-7.89h44.76v-76.48H282m2-2h-11.84v76.49H227.4v11.89h44.76v76.43H284v-76.44h44.7v-11.89H284v-76.49z",
    className: "electricCarChargers_before_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_before_svg__Haus_links"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 368.96,
    height: 263.65,
    x: 891.05,
    y: 268.71,
    className: "electricCarChargers_before_svg__cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259 269.71v261.66H892V269.71h367m2-2H890v265.66h371V267.71z",
    className: "electricCarChargers_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 165.47,
    height: 191.35,
    x: 939.52,
    y: 340.72,
    fill: "#9e6b54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104 341.72v189.35H940.52V341.72H1104m2-2H938.52v193.35H1106V339.72z",
    className: "electricCarChargers_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 132.83,
    height: 179.85,
    x: 954.74,
    y: 352.22,
    className: "electricCarChargers_before_svg__cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.57 353.22v177.85H955.74V353.22h130.83m2-2H953.74v181.85h134.83V351.22z",
    className: "electricCarChargers_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940.52,
    x2: 955.74,
    y1: 341.72,
    y2: 353.22,
    className: "electricCarChargers_before_svg__cls-8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1103.99,
    x2: 1086.57,
    y1: 341.72,
    y2: 353.22,
    className: "electricCarChargers_before_svg__cls-8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 82.02,
    height: 167.27,
    x: 981.25,
    y: 364.42,
    className: "electricCarChargers_before_svg__cls-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1020.1 531.59 1020.1 488.46 981.25 488.46 981.25 484.04 1020.1 484.04 1020.1 444.36 981.25 444.36 981.25 439.94 1020.1 439.94 1020.1 400.67 981.25 400.67 981.25 396.25 1020.1 396.25 1020.1 364.7 1024.52 364.7 1024.52 396.25 1063.05 396.25 1063.05 400.67 1024.52 400.67 1024.52 439.94 1063.05 439.94 1063.05 444.36 1024.52 444.36 1024.52 484.04 1063.21 484.04 1063.21 488.46 1024.52 488.46 1024.52 531.59 1020.1 531.59",
    className: "electricCarChargers_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.52 365.7v31.54h38.53v2.43h-38.53v41.26h38.53v2.43h-38.53V485h38.69v2.42h-38.69v43.13h-2.43v-43.09h-38.83V485h38.83v-41.64h-38.83v-2.43h38.83v-41.26h-38.83v-2.43h38.83V365.7h2.43m2-2h-6.43v31.54h-38.83v6.43h38.83v37.26h-38.83v6.43h38.83V483h-38.83v6.42h38.83v43.13h6.43v-43.09h38.69V483h-38.69v-37.64h38.53v-6.43h-38.53v-37.26h38.53v-6.43h-38.53V363.7z",
    className: "electricCarChargers_before_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_before_svg__Baum5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.19,
    cy: 411.47,
    className: "electricCarChargers_before_svg__cls-12",
    rx: 90.61,
    ry: 91.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.15 413.21c0-50.43 40.57-91.32 90.61-91.32 2.07 0 4.13.08 6.17.22a89.79 89.79 0 00-18.74-2c-50 0-90.61 40.88-90.61 91.32 0 48.35 37.28 87.91 84.44 91.11a91.18 91.18 0 01-71.87-89.33z",
    className: "electricCarChargers_before_svg__cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.11 679a4.62 4.62 0 01-3.32-1.42 4.42 4.42 0 01-1.22-3.28L151 462l-16.36-16.53a1.52 1.52 0 01-.34-1.68 1.54 1.54 0 011.42-.95 1.51 1.51 0 01.68.16l15.38 7.5 2.22-31.6.13-2.52a4.36 4.36 0 018.71-.16l1.44 19.71 15.28-8.15h.15a2.92 2.92 0 01.5-.05 2.63 2.63 0 012.5 1.83 2.67 2.67 0 01-.91 3l-16.11 11.72 14.53 229.87a4.39 4.39 0 01-1.16 3.36 4.55 4.55 0 01-3.37 1.48z",
    className: "electricCarChargers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.46 413.21a3.26 3.26 0 013.34 3.1l1.55 21.23 16.5-8.8a1.73 1.73 0 01.32 0 1.69 1.69 0 011 3l-16.53 12 14.56 230.42a3.5 3.5 0 01-3.53 3.77h-34.56a3.5 3.5 0 01-3.54-3.65l14.49-212.74-16.68-16.85a.54.54 0 01.37-.93.52.52 0 01.24 0l16.72 8.24 2.29-33 .13-2.54a3.27 3.27 0 013.37-3.22m0-2a5.26 5.26 0 00-5.37 5.12l-.13 2.53-2 30-14-6.85a2.45 2.45 0 00-1.12-.26 2.54 2.54 0 00-1.8 4.33L150 462.33l-14.42 211.85a5.39 5.39 0 001.49 4.05 5.59 5.59 0 004 1.73h34.54a5.59 5.59 0 004.11-1.8 5.44 5.44 0 001.41-4.15l-14.44-229.27 15.64-11.39a3.69 3.69 0 00-2.16-6.64 3.79 3.79 0 00-.67.06l-.31.06-.28.15-13.79 7.35-1.32-18.17a5.3 5.3 0 00-5.34-5z",
    className: "electricCarChargers_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "electricCarChargers_before_svg__cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.48 439.29l18.13-9.67a1.61 1.61 0 00-1.76-.88l-16.5 8.8zM156 453.61l2.37-34.61.13-2.54a3.25 3.25 0 011.66-2.78 3.37 3.37 0 00-5.07 2.78L155 419l-2.24 33zM141 674.31l14.48-212.74-15.73-15.9-3.75-1.83a.54.54 0 00-.61.88l16.68 16.85-14.5 212.74a3.5 3.5 0 003.54 3.65h3.41a3.5 3.5 0 01-3.52-3.65z",
    className: "electricCarChargers_before_svg__cls-16"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_before_svg__Baum4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.42,
    cy: 368.85,
    className: "electricCarChargers_before_svg__cls-12",
    rx: 114.48,
    ry: 115.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-72.19 371.05c0-63.73 51.26-115.39 114.49-115.39 2.62 0 5.21.1 7.79.27a114 114 0 00-23.67-2.47c-63.23 0-114.49 51.66-114.49 115.39 0 61.08 47.1 111.08 106.7 115.11C-33.24 473-72.19 426.6-72.19 371.05z",
    className: "electricCarChargers_before_svg__cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.15 706.56a5.53 5.53 0 01-4-1.7 5.3 5.3 0 01-1.48-4L24 432.53l-20.76-21a1.65 1.65 0 01-.36-1.83 1.65 1.65 0 012.29-.87l19.78 9.65 2.75-40.26.16-3.19a5.25 5.25 0 0110.48-.19l1.84 25.31 19.63-10.47h.16a2.83 2.83 0 01.57-.06 3.13 3.13 0 011.85 5.62l-20.5 14.9 18.37 290.59a5.38 5.38 0 01-1.39 4 5.5 5.5 0 01-4.07 1.78z",
    className: "electricCarChargers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.07 371.05A4.12 4.12 0 0137.3 375l2 26.83 20.8-11.16a2.85 2.85 0 01.4 0 2.14 2.14 0 011.24 3.83l-20.88 15.2 18.4 291.1a4.43 4.43 0 01-4.46 4.76H11.15A4.43 4.43 0 016.68 701L25 432.15 3.91 410.86a.69.69 0 01.47-1.18.73.73 0 01.31.07l21.12 10.31 2.84-41.74.17-3.2a4.13 4.13 0 014.25-4.07m0-2a6.13 6.13 0 00-6.25 6l-.16 3.21L24 417l-18.44-9a2.56 2.56 0 00-1.18-.28 2.68 2.68 0 00-1.89 4.58l20.44 20.65L4.69 700.82a6.34 6.34 0 001.74 4.73 6.54 6.54 0 004.72 2H54.8a6.49 6.49 0 004.8-2.1 6.35 6.35 0 001.65-4.84l-18.32-290 20-14.56a4.13 4.13 0 00-2.46-7.41 4.76 4.76 0 00-.75.07l-.31.06-.28.15L41 398.58l-1.74-23.77a6.09 6.09 0 00-6.22-5.76z",
    className: "electricCarChargers_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "electricCarChargers_before_svg__cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.42 404l22.91-12.22a2 2 0 00-2.23-1.11l-20.85 11.12zM30 422.09l3-43.77.16-3.2a4.07 4.07 0 012.1-3.52 4.26 4.26 0 00-6.41 3.52l-.17 3.2-2.83 41.74zM11 701l18.3-268.85-19.88-20.09-4.73-2.31a.69.69 0 00-.78 1.11L25 432.15 6.68 701a4.43 4.43 0 004.47 4.6h4.32A4.42 4.42 0 0111 701z",
    className: "electricCarChargers_before_svg__cls-16"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_before_svg__Stra\\xDFe"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#898989",
    points: "-1 982.96 -1 771.44 463.81 531.58 794.2 533.99 1259 771.43 1259 982.96 -1 982.96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.05 532.59L794 535l464 237.05V982H0V772.05l464.05-239.46m-.48-2l-.44.23L-.92 770.27l-1.08.56V984h1262V770.82l-1.09-.56-464.05-237-.42-.21H794l-329.91-2.4z",
    className: "electricCarChargers_before_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_before_svg__Stra\\xDFenmarkierung"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "644.59 981.96 620.42 981.96 622.28 898.15 641.32 898.15 644.59 981.96",
    className: "electricCarChargers_before_svg__cls-18"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "641.32 829.5 622.28 829.5 625.95 745.7 639.82 745.7 641.32 829.5",
    className: "electricCarChargers_before_svg__cls-18"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "636.56 592.13 627.04 592.13 629.44 550.23 635.06 550.23 636.56 592.13",
    className: "electricCarChargers_before_svg__cls-18"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "636.56 614.85 627.04 614.85 625.95 684.48 639.82 684.48 636.56 614.85",
    className: "electricCarChargers_before_svg__cls-18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_before_svg__Auto_rechts"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M927.56 501.94l34.88-16.86-29.06-27.34c-.61.29-42.28-8-42.9-7.72a27.8 27.8 0 00-4.12 2.43L783 450l-10.6 3.83c-.81-.39-2.42 2.46-3.23 2.07-.61-.3-.42 3-1 2.67l-31.77 29.89 36.4 18.35c8.84-12.84 20.05-21.68 44.84-19.47h50.7c27.19.31 49.04 6.53 59.22 14.6z",
    className: "electricCarChargers_before_svg__cls-19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a81628",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.86,
    d: "M880.75 485.63h-60.39c-33.66 0-61 19.21-61 42.9l-30.54 5.34h246.93l-34-5.34c-.05-23.69-27.34-42.9-61-42.9zm54 42h-168.3v-.82c0-21 24.17-38 54-38h60.37c29.81 0 54 17 54 38z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.55,
    height: 24.01,
    x: 801.55,
    y: 518.27,
    className: "electricCarChargers_before_svg__cls-21",
    transform: "rotate(-29.97 803.986 530.328)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.01,
    height: 4.55,
    x: 811.73,
    y: 528,
    className: "electricCarChargers_before_svg__cls-21",
    transform: "rotate(-60.02 823.764 530.271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.45 579.58a34.37 34.37 0 1134.37-34.36 34.39 34.39 0 01-34.37 34.36zm0-61.91A27.55 27.55 0 10842 545.22a27.57 27.57 0 00-27.55-27.55z",
    className: "electricCarChargers_before_svg__cls-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.25 589.62l5.11-58.41a6.93 6.93 0 00-6.93-6.93h-36.7a6.93 6.93 0 00-6.93 6.93l6.2 58.95 30.91-.42c3.22-.08 8.47 1.5 8.34-.12z",
    className: "electricCarChargers_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.78 517.29c-.24.87-1.55 6.12 2.69 9.32a9.34 9.34 0 002.15 1.21l1.07-.4c.87-.45 4-2.16 4.84-5.27a6 6 0 000-3.24",
    className: "electricCarChargers_before_svg__cls-23"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "763.89 527.82 762.54 531.75 754 580.33 763.89 584.34 771.41 542.03",
    className: "electricCarChargers_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.17 527.35l1.94 3.67 16 46.66-1.64 1-7.5 4.51q-7-20.31-14-40.63",
    className: "electricCarChargers_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.5 504.66c-3.35-.68-5.82-3-5.82-5.74s2.35-5 5.59-5.69M810.31 504.72c3.36-.68 5.83-3 5.83-5.75s-2.36-5-5.59-5.69",
    className: "electricCarChargers_before_svg__cls-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.71 481.09c-.42-1.73-3.05-10.89-3.4-10.35a16.1 16.1 0 00-3.94-4.68c-3.83-2.9-7.6-3.6-10.83-4.2-1.42-.26-18.29.32-18.39.94s-1.95 1.78-2.59 2.21a18.7 18.7 0 00-5.94 6.64 25.63 25.63 0 00-2.45 7c-.21.87-.6 2.47-.92 4.6a3.93 3.93 0 01.23 3.66c-.93 2.74-1.11 4.44-.58 4.21.09.81 4 14 4 14.72v.5a14.19 14.19 0 00.18 3.22 14.72 14.72 0 003.3 6.8 19.88 19.88 0 008.62 6.14 20.33 20.33 0 0013.39.5 29.3 29.3 0 005.8-3.08 44.06 44.06 0 006.94-5.37c1.47-1.28 2.21-2 2.51-3.22a17.18 17.18 0 00.14-3.51v-1.93l.51-1.17c0-2.82 3.42-15.26 3.43-17.18.06-3.67.44-4.65-.01-6.45z",
    className: "electricCarChargers_before_svg__cls-24"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.07,
    height: 46.68,
    x: 668.3,
    y: 689.81,
    className: "electricCarChargers_before_svg__cls-25",
    rx: 9.09
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.07,
    height: 46.68,
    x: 973.04,
    y: 689.81,
    className: "electricCarChargers_before_svg__cls-25",
    rx: 9.09
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.06 528.24c-2.62-4.69-6.51-6.93-9.8-8.77 0 0-10.75-6-31.74-2.06a5.53 5.53 0 00-2.83 1.29c-3 2.74-1.55 8.76-1.29 9.8 1.72 7.07 7.48 11.22 11.61 14.19a41 41 0 0012.12 5.93c3.39 1 6.5 2 10.58 1.55 2.58-.25 9.11-.89 12.38-5.93 4.14-6.39-.3-14.68-1.03-16zM982.2 530.46c2.62-4.69 6.51-6.93 9.8-8.77 0 0 10.75-6 31.73-2.06a5.55 5.55 0 012.84 1.29c3 2.74 1.54 8.76 1.29 9.8-1.73 7.07-7.49 11.22-11.61 14.19a40.94 40.94 0 01-12.13 5.93c-3.39 1-6.5 1.95-10.57 1.55-2.58-.25-9.12-.89-12.39-5.93-4.16-6.38.3-14.68 1.04-16z",
    className: "electricCarChargers_before_svg__cls-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.39 541.41c0-4.28-58.71-6-134.33-6s-134.92 2.14-134.92 6.42l-59.06 34.68 392 3.2z",
    className: "electricCarChargers_before_svg__cls-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.61 577.24c-14.35-10.2-96.64-18-196-18-104.92 0-190.79 8.71-197.75 19.74a20.65 20.65 0 00-9.16 17.19V649h.06c2.72 10.25 94.6 18.49 207.54 18.49s204.83-8.24 207.55-18.49h.06v-52.84a20.68 20.68 0 00-12.3-18.92z",
    className: "electricCarChargers_before_svg__cls-26"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 848.83,
    x2: 848.82,
    y1: 479.51,
    y2: 493.81,
    fill: "none",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 4.44
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8a9ad",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M1063.41 649.56a9.1 9.1 0 00-3.5-7.15V649h-.06c-2.72 10.25-94.6 18.49-207.55 18.49S647.48 659.23 644.76 649h-.06v-6.54a9.09 9.09 0 00-3.46 7.12v31.73a8.64 8.64 0 00.28 2.16 2.67 2.67 0 00-.28 1.15c0 12.49 94.51 22.61 211.09 22.61s211.08-10.12 211.08-22.61a2.65 2.65 0 00-.27-1.15 9.13 9.13 0 00.27-2.16z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.37,
    height: 10.48,
    x: 829.14,
    y: 488.57,
    className: "electricCarChargers_before_svg__cls-21",
    rx: 3.86
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "720.85 535.78 980.39 539.61 973.22 495.75 946.74 467.06 924.83 452.35 873.93 448.57 774.82 453.69 749.39 470.92 727.37 502.42 720.85 535.78",
    className: "electricCarChargers_before_svg__cls-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.81 445.82h-89.16a90 90 0 00-90 90v5.85h269.12v-5.85a90 90 0 00-89.96-90zm79.77 88.05H728.07v-1.72a79.7 79.7 0 0179.7-79.7h89.12a79.69 79.69 0 0179.69 79.7z",
    className: "electricCarChargers_before_svg__cls-26"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 51.94,
    height: 28.01,
    x: 650.9,
    y: 586.82,
    className: "electricCarChargers_before_svg__cls-30",
    rx: 9.09
  }), /*#__PURE__*/React.createElement("rect", {
    width: 51.94,
    height: 28.01,
    x: 1000.41,
    y: 586.46,
    className: "electricCarChargers_before_svg__cls-30",
    rx: 9.09
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bcbcbc",
    d: "M735.62 663.69a25.16 25.16 0 00-38.52-31 29.65 29.65 0 00-7.87 1.29 31.76 31.76 0 00-17.17-43.47l.18-.56c.79 0 1.59.09 2.39.09a34.87 34.87 0 0026.1-58 44.53 44.53 0 00-3.07-81.04c19.73-9.63 32.89-26.88 32.89-46.58 0-11.94-4.85-23-13-32 19.46-9.67 32.4-26.8 32.4-46.33 0-26.75-24.27-49-56.32-53.73a44.62 44.62 0 004.34-19.1c0-30.19-30.9-54.67-69-54.67s-69 24.48-69 54.67c0 13.31 6 25.51 16 35-30.1 5.89-52.42 27.4-52.42 53.06 0 28.92 28.36 52.58 64.24 54.53a51.45 51.45 0 00-3.17 89c-14.74 5.93-24.66 16.94-24.66 29.55 0 18.89 22.23 34.21 49.65 34.21h1.46a53.24 53.24 0 00-6.1 25.16c0 19.88 10.2 36.71 24.28 42.44a32.41 32.41 0 00-.26 4 31.74 31.74 0 0042.16 30 29.4 29.4 0 0041.53 37.43 19.4 19.4 0 1023-23.9z",
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 743.3,
    cy: 686.66,
    r: 11.85,
    fill: "#343a50",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    width: 118.9,
    height: 29.06,
    x: 789.96,
    y: 625.47,
    fill: "#fff",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.86,
    rx: 11.33
  })), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_before_svg__Wolken"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.69-24.85c6.09-14.3 21.48-24.51 39.64-24.51 17.95 0 33.23 10 39.46 24a32.55 32.55 0 018-1.11c16.4 0 29.68 11.85 29.68 26.46s-13.28 26.46-29.68 26.46h-77.13C171.26 26.43 158 14.59 158 0c0-11.51 8.23-21.19 19.69-24.85zM664.61 55.53c10.22-24 36.07-41.16 66.58-41.16 30.15 0 55.8 16.71 66.27 40.26A55.23 55.23 0 01811 52.78c27.54 0 49.85 19.9 49.85 44.44s-22.36 44.44-49.85 44.44H681.34c-27.53 0-49.84-19.9-49.84-44.44 0-19.29 13.86-35.54 33.11-41.69zM503.8-.19c-6.61-15.55-23.34-26.65-43.1-26.65-19.52 0-36.13 10.82-42.9 26.07A35.79 35.79 0 00409.06-2c-17.82 0-32.27 12.88-32.27 28.77s14.45 28.77 32.27 28.77H493c17.83 0 32.28-12.88 32.28-28.77-.03-12.46-9.01-22.98-21.48-26.96zM923 23.57C928.75 10.08 943.27.44 960.42.44c16.94 0 31.36 9.39 37.24 22.63a31 31 0 017.58-1c15.48 0 28 11.18 28 25s-12.54 25-28 25h-72.83c-15.47 0-28-11.19-28-25-.01-10.91 7.78-20.07 18.59-23.5z",
    className: "electricCarChargers_before_svg__cls-34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_before_svg__Baum3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1090.15,
    cy: 381.31,
    className: "electricCarChargers_before_svg__cls-12",
    rx: 87.01,
    ry: 87.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.21 383c0-48.44 39-87.7 87-87.7q3 0 5.93.21a86.83 86.83 0 00-18-1.89c-48.05 0-87 39.27-87 87.71 0 46.43 35.8 84.42 81.09 87.49a87.56 87.56 0 01-69.02-85.82z",
    className: "electricCarChargers_before_svg__cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078.55 638.23a4.46 4.46 0 01-3.21-1.37 4.29 4.29 0 01-1.19-3.18L1088 429.8l-15.71-15.86a1.53 1.53 0 011.07-2.6 1.44 1.44 0 01.67.16l14.72 7.18 2.06-30.24.19-2.44a4.23 4.23 0 018.44-.16l1.37 18.88 14.63-7.8h.16a2.59 2.59 0 01.48 0 2.61 2.61 0 011.55 4.69l-15.45 11.25 13.95 220.73a4.3 4.3 0 01-1.12 3.26 4.43 4.43 0 01-3.27 1.43z",
    className: "electricCarChargers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.21 383a3.12 3.12 0 013.21 3l1.49 20.39 15.84-8.45a1.67 1.67 0 01.31 0 1.61 1.61 0 01.94 2.9l-15.87 11.55 14 221.29a3.36 3.36 0 01-3.39 3.62h-33.17a3.38 3.38 0 01-3.4-3.5l13.92-204.31-16-16.19a.53.53 0 01.36-.89.53.53 0 01.24.06l16 7.83 2.16-31.72.13-2.44a3.13 3.13 0 013.23-3.09m0-2a5.13 5.13 0 00-5.23 5l-.13 2.43-1.95 28.73-13.39-6.53a2.52 2.52 0 00-2.89 4l15.38 15.5-13.85 203.41a5.28 5.28 0 001.45 4 5.47 5.47 0 003.94 1.68h33.17a5.43 5.43 0 004-1.76 5.31 5.31 0 001.37-4l-13.9-220.14 15-10.9a3.62 3.62 0 00-2.12-6.52 3.67 3.67 0 00-.66.05l-.31.06-.28.15-13.13 7-1.26-17.32a5.17 5.17 0 00-5.21-4.83z",
    className: "electricCarChargers_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "electricCarChargers_before_svg__cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1100 408l17.42-9.29a1.55 1.55 0 00-1.7-.85l-15.84 8.45zM1092.87 421.78l2.26-33.27.13-2.44a3.08 3.08 0 011.59-2.67 3.23 3.23 0 00-4.87 2.67l-.13 2.44-2.15 31.72zM1078.43 633.73l13.91-204.31-15.11-15.27-3.59-1.75a.52.52 0 00-.6.83l16 16.19-13.92 204.31a3.38 3.38 0 003.4 3.5h3.28a3.38 3.38 0 01-3.37-3.5z",
    className: "electricCarChargers_before_svg__cls-16"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_before_svg__Baum2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1166.47,
    cy: 509.41,
    className: "electricCarChargers_before_svg__cls-12",
    rx: 61.55,
    ry: 62.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1113.46 510.6c0-34.27 27.56-62 61.55-62 1.41 0 2.81.05 4.19.14a61.36 61.36 0 00-12.73-1.33c-34 0-61.55 27.78-61.55 62 0 32.85 25.32 59.73 57.36 61.9a62 62 0 01-48.82-60.71z",
    className: "electricCarChargers_before_svg__cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.26 691.45a3.42 3.42 0 01-2.48-1.06 3.31 3.31 0 01-.92-2.46l9.81-144.1-11-11.13a1.37 1.37 0 011-2.33 1.33 1.33 0 01.61.14l10 4.89 1.43-21 .08-1.71a3.29 3.29 0 016.56-.12l.94 12.91 10-5.33h.55a2.12 2.12 0 012 1.45 2.1 2.1 0 01-.73 2.39l-10.8 7.87 9.86 156a3.34 3.34 0 01-.87 2.52 3.46 3.46 0 01-2.53 1.1z",
    className: "electricCarChargers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.05 510.6a2.21 2.21 0 012.27 2.1l1 14.42 11.21-6h.22a1.14 1.14 0 01.67 2l-11.23 8.17 9.89 156.54a2.38 2.38 0 01-2.4 2.56h-23.47a2.38 2.38 0 01-2.4-2.47l9.84-144.54-11.28-11.38a.37.37 0 01.25-.63.35.35 0 01.17 0l11.36 5.54 1.52-22.45.09-1.72a2.22 2.22 0 012.29-2.18m0-2a4.2 4.2 0 00-4.29 4.08l-.08 1.72-1.33 19.45-8.69-4.24a2.36 2.36 0 00-3.22 1.22 2.34 2.34 0 00.51 2.57l10.7 10.81-9.78 143.63a4.31 4.31 0 001.18 3.24 4.46 4.46 0 003.21 1.37h23.47A4.46 4.46 0 001185 691a4.34 4.34 0 001.12-3.31l-9.82-155.39 10.34-7.52a3.14 3.14 0 00-1.84-5.67 2.75 2.75 0 00-.57 0l-.31.05-.28.15-8.49 4.53-.83-11.36a4.23 4.23 0 00-4.27-3.95z",
    className: "electricCarChargers_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "electricCarChargers_before_svg__cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1173.46 528.31l12.32-6.57a1.12 1.12 0 00-1.2-.6l-11.21 6zM1168.4 538l1.6-23.5.09-1.72a2.19 2.19 0 011.13-1.89 2.29 2.29 0 00-3.45 1.89l-.09 1.72-1.53 22.5zM1158.18 688l9.82-144.56-10.69-10.79-2.54-1.24a.37.37 0 00-.42.59l11.33 11.44-9.82 144.56a2.38 2.38 0 002.4 2.47h2.32a2.38 2.38 0 01-2.4-2.47z",
    className: "electricCarChargers_before_svg__cls-16"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_before_svg__Baum1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1241.33,
    cy: 371.01,
    className: "electricCarChargers_before_svg__cls-12",
    rx: 122.4,
    ry: 123.37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.9 373.37c0-68.14 54.8-123.37 122.41-123.37 2.8 0 5.57.1 8.33.29a122.1 122.1 0 00-25.31-2.65c-67.61 0-122.41 55.23-122.41 123.37 0 65.31 50.36 118.76 114.08 123.08-55.46-11.75-97.1-61.34-97.1-120.72z",
    className: "electricCarChargers_before_svg__cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225 732a5.84 5.84 0 01-4.23-1.8 5.59 5.59 0 01-1.55-4.17l19.54-287-22.22-22.44a1.74 1.74 0 011.21-3 1.74 1.74 0 01.77.18l21.25 10.36 2.94-43.14.17-3.41a5.55 5.55 0 0111.07-.2l2 27.16 21.05-11.16h.15a3.23 3.23 0 01.61-.06 3.2 3.2 0 013 2.23 3.23 3.23 0 01-1.11 3.65l-21.9 15.94 19.63 310.73a5.63 5.63 0 01-1.46 4.28 5.84 5.84 0 01-4.3 1.88z",
    className: "electricCarChargers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.44 373.37a4.4 4.4 0 014.52 4.17l2.09 28.69 22.29-11.89a2.09 2.09 0 01.43 0 2.28 2.28 0 011.32 4.09l-22.32 16.25 19.67 311.28a4.73 4.73 0 01-4.77 5.09H1225a4.73 4.73 0 01-4.78-4.92l19.57-287.41-22.54-22.76a.73.73 0 01.5-1.25.78.78 0 01.33.07l22.59 11 3-44.62.17-3.43a4.41 4.41 0 014.55-4.34m0-2a6.42 6.42 0 00-6.55 6.24l-.17 3.42-2.84 41.63L1219 413a2.69 2.69 0 00-1.21-.28 2.73 2.73 0 00-1.92 4.66l21.9 22.12-19.54 286.5a6.63 6.63 0 001.83 4.95 6.85 6.85 0 005 2.11h46.66a6.83 6.83 0 005-2.2 6.68 6.68 0 001.73-5.07l-19.6-310.13 21.42-15.66a4.28 4.28 0 00-2.5-7.7 5.14 5.14 0 00-.78.07l-.31.06-.28.15-19.58 10.42-1.82-25.6a6.37 6.37 0 00-6.51-6z",
    className: "electricCarChargers_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "electricCarChargers_before_svg__cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1255.22 408.59l24.5-13.06a2.17 2.17 0 00-2.38-1.19l-22.29 11.89zM1245.15 427.94l3.18-46.8.17-3.43a4.39 4.39 0 012.24-3.76 4.55 4.55 0 00-6.85 3.76l-.18 3.43-3 44.62zM1224.84 726.09l19.57-287.41-21.26-21.47-5.06-2.47a.73.73 0 00-.83 1.18l22.54 22.76-19.57 287.41A4.73 4.73 0 001225 731h4.61a4.73 4.73 0 01-4.77-4.91z",
    className: "electricCarChargers_before_svg__cls-16"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_before_svg__Denkblase"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.98,
    cy: 334.79,
    className: "electricCarChargers_before_svg__cls-35",
    rx: 121.77,
    ry: 83.51
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 303.23,
    cy: 421.09,
    className: "electricCarChargers_before_svg__cls-35",
    rx: 18.66,
    ry: 15.73
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 323.67,
    cy: 447.75,
    className: "electricCarChargers_before_svg__cls-35",
    rx: 15.62,
    ry: 9.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346.12,
    cy: 471.27,
    r: 4.85,
    className: "electricCarChargers_before_svg__cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.58,
    d: "M150 369.09h109.36a10.37 10.37 0 0010.34-10.34v-6.82h5.51a10.36 10.36 0 0010.33-10.33v-13a10.36 10.36 0 00-10.33-10.34h-5.51v-6.82a10.37 10.37 0 00-10.34-10.33H150a10.36 10.36 0 00-10.33 10.33v47.29A10.36 10.36 0 00150 369.09z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.88,
    height: 52.35,
    x: 152.58,
    y: 308.96,
    className: "electricCarChargers_before_svg__cls-4",
    rx: 6.58
  })), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_before_svg__Auto_links"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.54,
    height: 78.4,
    x: 90.73,
    y: 850.14,
    className: "electricCarChargers_before_svg__cls-37",
    rx: 17.85
  }), /*#__PURE__*/React.createElement("rect", {
    width: 67.54,
    height: 78.4,
    x: 463.37,
    y: 850.14,
    className: "electricCarChargers_before_svg__cls-37",
    rx: 17.85
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.16 658.15 125.45 658.15 134.52 593.08 486.16 593.08 486.16 658.15",
    className: "electricCarChargers_before_svg__cls-38"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 233.61,
    height: 57.25,
    x: 199.34,
    y: 590.35,
    fill: "#b7b6b6",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.22 517.67 429.11 498.43 412.45 488.13 203.75 490.35 165.28 520.05 226.56 539.91 405.26 540.98 450.22 517.67",
    className: "electricCarChargers_before_svg__cls-38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5e5e5",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.13,
    d: "M236.72 544.13l71.26-1.4v0h1.55v0l70.19 1.39c20.61.42 39.87 68.9 41.82 76 .11.42.24.83.38 1.24l9.84 28.83H445L433.9 619c-.15-.43-.29-.87-.42-1.31-2.18-7.4-23.65-78.48-46.15-80.28L309.86 536v0h-1.71v0l-78.64 1.47c-23.76.81-44.36 71.45-46.78 80.05-.16.59-.35 1.17-.56 1.75l-11.23 31h13l9.72-28c.31-.91.59-1.82.84-2.74 2.67-10.16 20.88-75.16 42.22-75.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e5e5e5",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.13,
    points: "309.86 650.23 308.15 650.23 183.91 650.23 183.66 650.97 307.98 650.97 309.53 650.97 432.01 650.97 431.76 650.23 309.86 650.23",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.6 586.27h52a28.36 28.36 0 0128.4 28.36v37.14H331.24v-37.14a28.36 28.36 0 0128.36-28.36z",
    className: "electricCarChargers_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80.68,
    height: 41.27,
    x: 346.31,
    y: 540.59,
    className: "electricCarChargers_before_svg__cls-42",
    rx: 14.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.51 585.59h52A28.36 28.36 0 01284.89 614v37.1H176.14V614a28.36 28.36 0 0128.37-28.41z",
    className: "electricCarChargers_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80.68,
    height: 41.27,
    x: 191.21,
    y: 539.91,
    className: "electricCarChargers_before_svg__cls-42",
    rx: 14.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5166",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M409.58 687l7.11-81.33A9.65 9.65 0 00407 596h-51a9.65 9.65 0 00-9.65 9.65l8.61 82.08 43-.59c4.5-.14 11.81 2.09 11.62-.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.51 586.27c-.33 1.62-2.15 11.3 3.74 17.22a13.15 13.15 0 003 2.24l1.5-.74a16.21 16.21 0 006.74-9.74 15.05 15.05 0 000-6",
    className: "electricCarChargers_before_svg__cls-23"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382.25,
    x2: 381.13,
    y1: 605.73,
    y2: 688.1,
    fill: "none",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.45 521.46c-2.28-3.65-3.92-5.34-5.48-6.52-5.34-4-10.58-5-15.09-5.84-2-.37-25.46.44-25.6 1.3s-2.71 2.48-3.6 3.08a26 26 0 00-8.28 9.25c-1.77 3.18-2.42 5.78-3.4 9.73-.31 1.21-.84 3.44-1.29 6.4-.46-.51 1.6 1.31.31 5.08s-1.54 6.19-.81 5.86c.12 1.13.27 2.14.33 3.1l5.84.49 4.86-14.12 7.79-8.39 9.25 2.55 9.25 6.33 11.66 4.18 13.75 10.42 5.25-1.46v-8c0-5.12.58-6.48 0-9s-4.26-15.2-4.74-14.44z",
    className: "electricCarChargers_before_svg__cls-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.24 568.68c-4.67-.94-8.11-4.16-8.11-8s3.28-6.9 7.78-7.92M412.45 568.76c4.67-.94 8.11-4.16 8.11-8s-3.28-6.9-7.78-7.92",
    className: "electricCarChargers_before_svg__cls-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.93 522.73a28.82 28.82 0 00-8.28 4.38c-8.7 7.27-9.61 18.57-9.73 21.9v2.43c0 6.39-.09 13.69.48 19a25.82 25.82 0 00.49 2.92 26.73 26.73 0 001.46 4.38c2.09 4.67 6.89 8.45 7.3 8.77a29.69 29.69 0 0011.68 5.35c3.52.84 9.5 2.35 16.06 0a38.71 38.71 0 006.57-3.65 50.61 50.61 0 0011.2-9.25c1.67-1.89 2.7-3.41 2.92-5.35.07-.62 0-1 0-3.41v-3.89c0-2.65.17-11.06.49-22.39a28.1 28.1 0 00-7.31-2.92c-4.23-1.06-12.11-5.65-22.38-11.68-3.23-1.89-5.8-3.45-8.76-5.36-2.35-1.5-4.32-2.84-5.85-3.89",
    className: "electricCarChargers_before_svg__cls-45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.16 543.17a7 7 0 013.9-2.43 7.17 7.17 0 015.84 1.46M393.6 543.94a6.92 6.92 0 013.89-2.43 7.17 7.17 0 015.84 1.46M375.82 579a14.77 14.77 0 014.87-1.94 14.33 14.33 0 015.84 0 14 14 0 015.35 2.43M379.23 567a4.38 4.38 0 008.27 0",
    className: "electricCarChargers_before_svg__cls-46"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 368.03,
    cy: 554.12,
    className: "electricCarChargers_before_svg__cls-35",
    rx: 4.87,
    ry: 3.65
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 398.69,
    cy: 554.12,
    className: "electricCarChargers_before_svg__cls-35",
    rx: 4.87,
    ry: 3.65
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 367.79,
    cy: 554.36,
    className: "electricCarChargers_before_svg__cls-4",
    rx: 1.7,
    ry: 2.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 398.45,
    cy: 553.88,
    className: "electricCarChargers_before_svg__cls-4",
    rx: 1.7,
    ry: 2.43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350 559.23a5.62 5.62 0 011.46-.49 5.69 5.69 0 011.95 0M415.24 563.61a2.28 2.28 0 001-1.46c.19-1.37-1.29-2.32-1.46-2.43a3.61 3.61 0 00-2.44-.49",
    className: "electricCarChargers_before_svg__cls-47"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#ff5166",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    points: "347.82 600.93 345.94 606.4 334.05 674.03 347.82 679.63 358.29 620.71"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5166",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.36,
    d: "M415 600.28l2.7 5.1 22.25 65-2.29 1.38-10.4 6.24-19.49-56.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba9079",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M375.06 585.59a14 14 0 00-1.5 1l-18.74-16.29c0 .22 0 .46-.05.7a19.3 19.3 0 00.25 4.48 20.55 20.55 0 004.59 9.47 27.68 27.68 0 0012.06 8.57c3.09 1.17 10.62 3.41 18.64.7 2.35-.79 4.25-2 8.07-4.28a61.87 61.87 0 009.67-7.48c2-1.79 3.07-2.84 3.49-4.48.13-.51.18-1 .2-4.89V570l-19.24 16a18.26 18.26 0 00-1.69-.85c-.44-.15-8.61-3.56-15.75.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    d: "M360.8 534c-1.19 0-1.23 4.37-3.81 11.4a5.8 5.8 0 00-.34 3.24c.3 1.42 1.34 3.28 2.9 3.58 2.28.43 4.81-2.63 5.15-5.36.16-1.24-.18-2-.89-4-2.35-6.75-2.2-8.79-3.01-8.86z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.33,
    height: 33.43,
    x: 369.54,
    y: 620.63,
    className: "electricCarChargers_before_svg__cls-21",
    transform: "rotate(-29.97 372.792 637.432)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.43,
    height: 6.33,
    x: 383.71,
    y: 634.18,
    className: "electricCarChargers_before_svg__cls-21",
    transform: "rotate(-60.02 400.442 637.35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.5 706a47.85 47.85 0 1147.85-47.85A47.9 47.9 0 01387.5 706zm0-86.2a38.36 38.36 0 1038.35 38.35 38.39 38.39 0 00-38.35-38.35z",
    className: "electricCarChargers_before_svg__cls-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.29 597.41c.64 5.44.07 14.62 0 15.66h16.17l-6 16.17c-23.72-.63-41.12-1.14-47-1.19a18.6 18.6 0 01-6-1c-1.82-.64-5.74-2-7.65-5.45-2-3.61-.78-7.61.34-11.23a25.28 25.28 0 016.29-10.73c6.17-6.08 14.08-6.9 23-7.83a74.47 74.47 0 0117.87.34 2.63 2.63 0 01.56.22c1.68.79 2.13 2.98 2.42 5.04zM507.39 597.33c-.65 5.44-.07 14.62 0 15.66h-16.17l5.95 16.17c23.72-.64 41.13-1.15 47-1.19a18.39 18.39 0 006-1c1.82-.63 5.74-2 7.66-5.44 2-3.61.78-7.61-.34-11.24a25.26 25.26 0 00-6.3-10.72c-6.16-6.09-14.08-6.91-23-7.83a73.94 73.94 0 00-17.87.34 3.41 3.41 0 00-.55.21c-1.64.79-2.14 2.97-2.38 5.04z",
    className: "electricCarChargers_before_svg__cls-52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.85 628.28a8.09 8.09 0 014.36-2.61 7.39 7.39 0 017.19 2.58c2.27 3 .61 7.11-.26 9.26a13.16 13.16 0 01-5.93 6.87c-2.28 1.21-7.17 2.86-9.6.71-3.42-3.02-.31-12.16 4.24-16.81zM427 625.63a8.61 8.61 0 00-5.17 1.57 6.17 6.17 0 00-2.72 5.18c.1 2.3 1.75 2.42 2.45 5.4.6 2.58-.45 3.3.54 5 1.21 2 3.87 2.78 4.36 2.92 3.73 1.07 8.64-.11 10.62-2.92 1.68-2.4.54-5-.82-8.11-.91-2.06-3.84-8.73-9.26-9.04z",
    className: "electricCarChargers_before_svg__cls-45"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.93,
    x2: 307.91,
    y1: 492.12,
    y2: 519.33,
    fill: "none",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 8.44
  }), /*#__PURE__*/React.createElement("rect", {
    width: 74.89,
    height: 19.93,
    x: 270.46,
    y: 509.36,
    className: "electricCarChargers_before_svg__cls-21",
    rx: 7.34
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "500.66 651.23 305.65 655.84 123.35 647.07 187.19 490.18 435.54 493.27 500.66 651.23",
    className: "electricCarChargers_before_svg__cls-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.83 494.24l102.28-2v-.05H310.34v.05l100.76 2c29.58.61 57.22 98.9 60 109.13.17.61.35 1.2.55 1.79l14.13 41.39h19.06l-16-44.81c-.22-.62-.43-1.24-.61-1.87-3.12-10.62-33.94-112.66-66.24-115.24l-111.2-2.11h-2.46l-112.88 2.11c-34.11 1.16-63.67 102.56-67.15 114.9-.24.85-.5 1.69-.8 2.51l-16.12 44.51H130l14-40.26q.67-1.95 1.2-3.93c3.85-14.48 30-107.78 60.63-108.12z",
    className: "electricCarChargers_before_svg__cls-54"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fcfcfc",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    points: "310.37 655.53 308.3 655.53 130.02 646.54 129.66 647.6 308.3 655.53 308.36 658.15 486.16 647.6 485.8 646.54 310.37 655.53",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6 720.71c2.6 1.54 6.4 3.77 11.05 6.38 4.37 2.45 23 12.93 34.21 17.36 17.32 6.87 32.86 5.64 43.91 5.11 40.33-2 80.66 4 121 5.1 112 3.09 115 9.1 131.74-1 18.46-11.17 52.24-41.18 68.43-38.3a25.26 25.26 0 0112.76 6.13c2.83 2.88 4 5.9 6.13 11.75a90.51 90.51 0 014.08 15.83c1.36 7.06 1.92 12.5 2 13.78.61 6.11.76 11.74 0 31.15 0 0-.91 23.27-3.07 41.88a85.78 85.78 0 01-1.53 9.19 92 92 0 01-3.74 12.25c-5.51 13.52-23.75 28.14-44.6 31.66-1.61.27-2.94.43-3.74.51-191.29.71-253.91.44-272.69 0-20-.46-32.44-2.09-57.44-.76-9.4.5-11.86.95-16.85 0-28.36-5.43-42.57-38-43.66-40.6-4.46-10.62-4.9-22.4-6.13-46-1.32-25.32 2-27.32.77-43.66a45.69 45.69 0 011.53-16.85 48.31 48.31 0 013.83-9.19c2-3.72 7.08-11.36 9.4-13.2z",
    className: "electricCarChargers_before_svg__cls-54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f3b3a",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M85.15 840.38a49.94 49.94 0 002.52 7.73c1.09 2.61 15.3 35.17 43.66 40.6 5 .95 7.45.5 16.85 0 25-1.33 37.4.3 57.44.76 18.78.44 81.4.71 272.69 0 .8-.08 2.13-.24 3.74-.51 20.85-3.52 39.09-18.14 44.6-31.66a92 92 0 003.74-12.25c.2-.87.36-1.68.51-2.47v-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eae9e8",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M496.43 641.17c3.08-.58 5.61-1.07 7.28-1.4l2.94 6.13c3.41 9.26 5.78 17.21 7.4 23.23 2.2 8.17 3.35 12.52 4.09 18.9 1 9-.38 8.07.76 18a67.15 67.15 0 01-.13 13.4 13.63 13.63 0 01-1.53 5.11 12.63 12.63 0 01-1.66 2.38 76.87 76.87 0 01-13.58 12.6c-13.94 9.27-26.9 16-26.9 16-12.57 6.51-18.85 9.77-26 12.59-6.32 2.48-5.89 2-31.15 9.36a74.21 74.21 0 01-14.3 2.9c-3.09.3-5.45.33-6.47.34-36.53.33-90.21 0-90.21 0-22 .49-44-.39-66 0-10.84.19-20.6.46-34-1.71a178.59 178.59 0 01-38.13-10.89c-4.79-1.89-12.27-5.57-27.24-12.94a261.14 261.14 0 01-25.87-14.63S111.75 738.2 103 730c-2.57-2.4-4.35-4.25-5.45-7.15-1.41-3.72-.61-7.07-.68-8.51a154 154 0 017.49-56.51 144.31 144.31 0 017.49-18c.88.24 2.24.6 3.91 1 0 0 9.72 2.43 20.09 3.92 23.35 3.35 55.32 4.08 55.32 4.08 48.17 1.11 15.11.75 55.57 1.45 40.1.69 60.15 1 76.34 1 28.59 0 17.31-.52 76.09-1.28 21.7-.28 47.09-.52 65.36-3.32 15.17-2.34 31.9-5.51 31.9-5.51z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.99,
    cy: 722.54,
    r: 7.39,
    fill: "#c2c2c2",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.35,
    cy: 676.31,
    r: 11.94,
    className: "electricCarChargers_before_svg__cls-30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492.92,
    cy: 676.31,
    r: 11.94,
    className: "electricCarChargers_before_svg__cls-30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.48,
    cy: 695.91,
    r: 10.79,
    className: "electricCarChargers_before_svg__cls-59"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.28,
    cy: 695.91,
    r: 10.79,
    className: "electricCarChargers_before_svg__cls-59"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231e1a",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M199.34 744.11h218v0a28.09 28.09 0 01-28.04 28.09H227.42a28.09 28.09 0 01-28.09-28.09v0h.01z"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricCarChargersbefore);
export default __webpack_public_path__ + "static/media/electricCarChargers.before.775c859b.svg";
export { ForwardRef as ReactComponent };